/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Container,
  ContainerView,
  DesktopContainer,
  MobileContainer,
  TitlePage,
} from "../../components/Container";
import { useEffect, useState } from "react";
import { cryptoType, gameType, useApp } from "../../contexts";
import {
  BalanceContainer,
  BalanceIcon,
  BalanceText,
  BalanceTitle,
  BalanceValue,
  BalanceValueBTC,
  BalanceValueBTC2,
  BalanceValueEqual,
  BalanceValueIcon,
  ButtonCreateWallet,
  CreateContainer,
  EmptyContainer,
  EmptyIcon,
  EqualIcon3,
  EyeIcon,
  IconHideAmount,
  IconHideAmountNew,
  NoEyeIcon,
} from "./styles";
import {
  formatCurrency,
  getWalletList,
  getWalletListSzt,
  getWalletListSgt,
  getWalletListOption,
  postCreateWallet,
  roundNumber,
} from "../../services/app";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import TabsCustom from "../../components/TabsCustom";
import { Tabs } from "antd";
import FormButton from "../../components/FormCustom2/Button";
import { TableCommon } from "./components/TableCommon";
import { TableOption } from "./components/TableOption";
import { findConversionRateBFS, isSOTd } from "../../utils/helper";
import { TYPE_WALLET_DETAIL } from "../../constants";
import { PaginationView, paginationRender } from "../../components/Table";
import { TableGame } from "./components/TableGame";
import { HistoryIcon } from "../../components/Icons/HistoryIcon";

export const TabWalletOption = {
  OPTION: TYPE_WALLET_DETAIL.OPTION,
  CRYPTO: "crypto",
  GAMECURRENCY: "gameCurrency",
  COMMISSION: "commission",
  STAKE: "stake",
};

function WalletList(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    setLoading,
    setAlert,
    currencyRates,
  } = useApp();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [searchParams] = useSearchParams();
  const { type } = {
    type: searchParams.get("type"),
    id: searchParams.get("id"),
    code: searchParams.get("code"),
    walletId: searchParams.get("walletId"),
    ...(useParams() || {}),
  };
  const pageSize = 15;

  let typeOrigin =
    type === TabWalletOption.COMMISSION ? TabWalletOption.GAMECURRENCY : type;
    
  if (!Object.values(TabWalletOption).includes(typeOrigin)) {
    typeOrigin = null;
  }

  const [tab, setTab] = useState(typeOrigin || TabWalletOption.CRYPTO);
  const [rows, setRows] = useState();
  const [visible, setVisible] = useState(false);
  const [stats, setStats] = useState([]);

  useEffect(() => {
    loadData();
  }, [tab, page]);

  const handleTabChange = (key) => {
    setTab(key);
    navigate(`/wallet?type=${key}`);
  };

  const convertData = (items) => {
    return (items || []).map((item) => {
      const marketPrice = findConversionRateBFS(
        currencyRates,
        item.currency_code,
        getCurrency()
      );
      return {
        ...item,
        coin: item.currency_code,
        amount: item.dog_food,
        marketPrice,
        btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
        local: convertToLocalCurrency(
          item.dog_food,
          item.currency_code,
          getCurrency()
        ),
      };
    });
  };

  const getTotalBalance = (currency) => {
    let totalBtc = 0.0;
    (stats || []).map((item) => {
      totalBtc += convertToBTC(
        item.total_available_balance || 0,
        item.currency_code,
        currency
      );
    });
    return {
      btc: totalBtc,
      local: convertToLocalCurrency(totalBtc, "BTC", currency),
    };
  };

  const convertBalance = () => {
    if (
      tab === TabWalletOption.OPTION ||
      tab === TabWalletOption.GAMECURRENCY ||
      tab === TabWalletOption.COMMISSION
    ) {
      let total = 0;
      let totalBtc = 0;
      for (let i = 0; i < rows?.length; i++) {
        total += rows[i]?.local || 0;
        totalBtc += rows[i]?.btc || 0;
      }
      return {
        game: {
          local: total,
          btc: totalBtc,
        },
      };
    }
    return {
      crypto: getTotalBalance(getCurrency()),
    };
  };

  const loadData = async () => {
    setLoading(true);
    let result = {};
    try {
      if (tab === TabWalletOption.GAMECURRENCY) {
        result = await Promise.all([getWalletListSzt(), getWalletListSgt()]);
        const resultSzt = result[0];
        const resultSgt = result[1];
        // const dataCommission = resultCommission?.data?.data;
        const dataGame = [];
        const dataStats = [];
        if (resultSgt?.data?.data) {
          dataGame.push({
            id: resultSgt?.data?.data?.id,
            dog_food: resultSgt?.data?.data?.dogFood || 0,
            possible_convert_balance:
              resultSgt?.data?.data?.possibleConvertBalance || 0,
            freeze_dog_food: resultSgt?.data?.data?.freezeDogFood || 0,
            member_id: resultSgt?.data?.data?.memberId,
            address: resultSgt?.data?.data?.address,
            currency_type: resultSgt?.data?.data?.type,
            currency_code: "SGT",
            create_time: resultSgt?.data?.data?.createTime,
            type: 5,
          });
          dataStats.push({
            currency_code: "SGT",
            total_available_balance: resultSgt?.data?.data?.dogFood  || 0,
            total_freeze_balance: resultSgt?.data?.data?.freezeDogFood  || 0,
          });
        }
        if (resultSzt?.data?.data) {
          dataGame.push({
            id: resultSzt?.data?.data?.id,
            dog_food: resultSzt?.data?.data?.dogFood,
            possible_convert_balance:
              resultSzt?.data?.data?.possibleConvertBalance,
            freeze_dog_food: resultSzt?.data?.data?.freezeDogFood,
            member_id: resultSzt?.data?.data?.memberId,
            address: resultSzt?.data?.data?.address,
            currency_type: resultSzt?.data?.data?.type,
            currency_code: "SZT",
            create_time: resultSzt?.data?.data?.createTime,
            type: 1,
          });
          dataStats.push({
            currency_code: "SZT",
            total_available_balance: resultSzt?.data?.data?.dogFood,
            total_freeze_balance: resultSzt?.data?.data?.freezeDogFood,
          });
        }
        
        setTotalData(dataGame?.length);
        setRows(convertData(dataGame));
        setStats(dataStats);
      } else if (tab === TabWalletOption.OPTION) {
        result = await getWalletListOption();
        if (result.status === 200) {
          let listWallets = result?.data?.data || [];
          if (!Array.isArray(listWallets)) {
            listWallets = [];
          }
          let items = (listWallets || []).map((item) => {
            return {
              ...item,
              currency_code: item.currencyCode,
              dog_food: item.originBalance,
            };
          });
          const stats = items.map((item) => {
            return {
              currency_code: item.currencyCode,
              total_available_balance: item.balance,
              total_freeze_balance: item.freezeBalance,
            };
          });
          setStats(stats);
          setTotalData(listWallets.length || 0);
          setRows(convertData(items));
        } else {
          setRows([]);
        }
      } else {
        result = await getWalletList({
          currencyType: cryptoType,
          page: page,
          size: pageSize,
        });
        if (result.status === 200) {
          let items = result?.data?.data?.wallets?.rows || [];
          setStats(result?.data?.data?.stats || []);
          if (tab === TYPE_WALLET_DETAIL.OPTION) {
            items = items.filter((item) => !!isSOTd(item?.currency_code));
          }
          if (tab === "gameCurrency") {
            items = items.filter((item) => !isSOTd(item?.currency_code));
          }
          setTotalData(result?.data?.data?.wallets?.count);
          setRows(convertData(items));
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onWithdraw = () => {
    if (tab === TYPE_WALLET_DETAIL.OPTION) {
      const item = rows.find((x) => x.can_auto_withdraw);
      if (item) {
        navigate(
          `/withdraw?type=${tab}&walletId=${item?.id}&code=${item.coin}`
        );
      }
    } else {
      navigate(
        `/withdraw?type=${tab}&walletId=${rows[0]?.id}&code=${rows[0].coin}`
      );
    }
  };
  const onTransactionHistory = () => {
    navigate(`/wallet-detail-history`);
  };
  const onCreateWallet = async () => {
    setLoading(true);
    const newCoins = hasNewCoins();
    for (let i = 0; i < newCoins.length; i++) {
      const result = await postCreateWallet(newCoins[i]).then();
      if (result.status !== 200) {
        setAlert({
          type: "error",
          text: result?.data?.error?.message,
        });
        setLoading(false);
        return;
      }
    }
    setAlert({
      type: "success",
      text: T("Wallet address created!"),
    });
    await loadData();
    setLoading(false);
  };

  const hasNewCoins = () => {
    const currentCoins = (rows || []).map((item) => item.currency_code);
    let allCoins = (currencies || [])
      .filter(
        (item) =>
          item.type === (tab === TabWalletOption.CRYPTO ? cryptoType : gameType)
      )
      .map((item) => item.code);
    if (tab === TabWalletOption.CRYPTO) {
      allCoins = ["ETH"];
    }
    if (tab === "gameCurrency") {
      allCoins = ["SZT"];
    }
    return allCoins.filter((item) => !currentCoins.find((x) => x === item));
  };

  const renderCreateWallet = () => {
    return (
      <EmptyContainer>
        <EmptyIcon />
        <h1>
          {T(
            tab === TYPE_WALLET_DETAIL.OPTION
              ? "You’ve got no opportunity token yet."
              : "You have no wallets yet."
          )}
        </h1>
        <CreateContainer>
          {tab !== TYPE_WALLET_DETAIL.OPTION ? (
            <ButtonCreateWallet className="primary2" onClick={onCreateWallet}>
              {T("Create wallets")}
            </ButtonCreateWallet>
          ) : null}
        </CreateContainer>
      </EmptyContainer>
    );
  };

  const rendertTabCrypto = () => (
    <>
      <BalanceContainer className="mt-[20px] lg:mt-[30px]">
        <div className="flex justify-start mt-[14px] lg:mt-[24px] flex-col lg:flex-row">
          <div className="flex-1 lg:w-full">
            <BalanceTitle>
              <BalanceText>{T("Estimated Balance")}</BalanceText>
            </BalanceTitle>
            <BalanceValue className="mt--3  flex-wrap">
              {!visible ? (
                <IconHideAmountNew style={{ fill: "#F12E11" }} />
              ) : (
                <>
                  <DesktopContainer>
                    <BalanceValueBTC2>
                      {formatCurrency(convertBalance()?.crypto?.btc || 0, 4)} BTC
                    </BalanceValueBTC2>
                  </DesktopContainer>
                  <MobileContainer>
                    <BalanceValueBTC>
                      {formatCurrency(convertBalance()?.crypto?.btc || 0, 4)} BTC
                    </BalanceValueBTC>
                  </MobileContainer>
                  <div className="flex items-center ml--3">
                    <BalanceValueIcon>
                      <EqualIcon3 />
                    </BalanceValueIcon>

                    <DesktopContainer>
                      <BalanceValueEqual>
                        {formatLocalCurrency(
                          roundNumber(convertBalance()?.crypto?.local || 0, 2)
                        )}
                      </BalanceValueEqual>
                    </DesktopContainer>
                    <MobileContainer>
                      <BalanceValueBTC2>
                        {formatLocalCurrency(
                          roundNumber(convertBalance()?.crypto?.local || 0, 2)
                        )}
                      </BalanceValueBTC2>
                    </MobileContainer>
                  </div>
                </>
              )}
              <BalanceIcon onClick={() => setVisible(!visible)}>
                {visible ? <EyeIcon /> : <NoEyeIcon />}
              </BalanceIcon>
            </BalanceValue>
          </div>
          <div className="w-full sm:w-auto">
            {hasNewCoins()?.length ? (
              <CreateContainer>
                <FormButton className="primary2 w-full" onClick={onCreateWallet}>
                  {T("Create wallets")}
                </FormButton>
              </CreateContainer>
            ) : (
              <div className="flex mt-6 w-full sm:w-auto">
                <FormButton
                  height={52}
                  width={175}
                  paddingLeft={20}
                  paddingRight={20}
                  paddingBottom={16}
                  paddingTop={16}
                  className="primary2 w-full sm:w-auto"
                  onClick={onWithdraw}
                  disabled={
                    tab === TYPE_WALLET_DETAIL.OPTION &&
                    !rows.find((x) => x.can_auto_withdraw)
                  }
                >
                  {T("Withdraw")}
                </FormButton> 
              </div>
            )}
          </div>
        </div>
      </BalanceContainer>
      <TableCommon visible={visible} tab={tab} data={convertData(rows)} />
    </>
  );

  const rendertTabGame = () => (
    <>
      <BalanceContainer className="mt-[20px] lg:mt-[30px]">
        <BalanceTitle>
          <BalanceText>{T("Estimated Balance")}</BalanceText>
        </BalanceTitle>

        <BalanceValue className="mt--3  flex-wrap">
          {/* {tab === TYPE_WALLET_DETAIL.OPTION && (
            <BalanceValueBTC>
              {!visible ? <IconHideAmount /> : "-"}
            </BalanceValueBTC>
          )} */}

          {/* {tab !== TYPE_WALLET_DETAIL.OPTION && ( */}
          <>
            {!visible ? (
              <IconHideAmount />
            ) : (
              <>
                <DesktopContainer>
                  <BalanceValueBTC2>
                    {formatCurrency(convertBalance()?.game?.btc || 0, 4)} BTC
                  </BalanceValueBTC2>
                </DesktopContainer>
                <MobileContainer>
                  <BalanceValueBTC>
                    {formatCurrency(convertBalance()?.game?.btc || 0, 4)} BTC
                  </BalanceValueBTC>
                </MobileContainer>

                <div className="flex items-center ml--3">
                  <BalanceValueIcon>
                    <EqualIcon3 />
                  </BalanceValueIcon>

                  <DesktopContainer>
                    <BalanceValueEqual>
                      {formatLocalCurrency(
                        roundNumber(convertBalance()?.game?.local || 0, 2)
                      )}
                    </BalanceValueEqual>
                  </DesktopContainer>
                  <MobileContainer>
                    <BalanceValueBTC2>
                      {formatLocalCurrency(
                        roundNumber(convertBalance()?.game?.local || 0, 2)
                      )}
                    </BalanceValueBTC2>
                  </MobileContainer>
                </div>
              </>
            )}
          </>

          <BalanceIcon onClick={() => setVisible(!visible)}>
            {visible ? <EyeIcon /> : <NoEyeIcon />}
          </BalanceIcon>
        </BalanceValue>

      </BalanceContainer>
      <TableGame visible={visible} tab={tab} data={convertData(rows)} />
    </>
  );
  const rendertTabOption = () => (
    <>
      <BalanceContainer className="mt-[20px] lg:mt-[30px]">
        <BalanceTitle>
          <BalanceText>{T("Estimated Balance")}</BalanceText>
        </BalanceTitle>

        <BalanceValue className="mt--3  flex-wrap">
          <>
            {!visible ? (
              <IconHideAmount />
            ) : (
              <>
                <DesktopContainer>
                  <BalanceValueBTC2>
                    {formatCurrency(convertBalance()?.game?.btc || 0, 4)} BTC
                  </BalanceValueBTC2>
                </DesktopContainer>
                <MobileContainer>
                  <BalanceValueBTC>
                    {formatCurrency(convertBalance()?.game?.btc || 0, 4)} BTC
                  </BalanceValueBTC>
                </MobileContainer>

                <div className="flex items-center ml--3">
                  <BalanceValueIcon>
                    <EqualIcon3 />
                  </BalanceValueIcon>

                  <DesktopContainer>
                    <BalanceValueEqual>
                      {formatLocalCurrency(
                        roundNumber(convertBalance()?.game?.local || 0, 2)
                      )}
                    </BalanceValueEqual>
                  </DesktopContainer>
                  <MobileContainer>
                    <BalanceValueBTC2>
                      {formatLocalCurrency(
                        roundNumber(convertBalance()?.game?.local || 0, 2)
                      )}
                    </BalanceValueBTC2>
                  </MobileContainer>
                </div>
              </>
            )}
          </>
          {/* )} */}

          <BalanceIcon onClick={() => setVisible(!visible)}>
            {visible ? <EyeIcon /> : <NoEyeIcon />}
          </BalanceIcon>
        </BalanceValue>
      </BalanceContainer>
      <TableOption visible={visible} tab={tab} data={convertData(rows)} />
    </>
  );
  return (
    <Container>
      <ContainerView background="transparent">
        <div className="flex justify-between items-center">
          <TitlePage>{T("Wallet")}</TitlePage>

          <div
            className="cursor-pointer w-[26px] lg:w-[32px]"
            onClick={() => onTransactionHistory()}
          >
            <HistoryIcon/>
          </div>
        </div>
        <TabsCustom
          className="v2 mt-[18px]  lg:mt-[40px] xls:[54px]"
          activeKey={tab}
          onChange={(e) => handleTabChange(e)}
        >
          <Tabs.TabPane tab={T("Crypto")} key={TabWalletOption.CRYPTO}>
            {!rows?.length
              ? renderCreateWallet()
              : TabWalletOption.CRYPTO === tab && rendertTabCrypto()}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={T("Credits")}
            key={TabWalletOption.GAMECURRENCY}
          >
            {!rows?.length
              ? renderCreateWallet()
              : TabWalletOption.GAMECURRENCY === tab && rendertTabGame()}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={T("Opportunity token")}
            key={TabWalletOption.OPTION}
          >
            {!rows?.length
              ? renderCreateWallet()
              : TabWalletOption.OPTION === tab && rendertTabOption()}
          </Tabs.TabPane>
        </TabsCustom>
        {(totalData > pageSize && tab !== TabWalletOption.OPTION) ? (
          <PaginationView
            current={page}
            pageSize={pageSize}
            onChange={(p, ps) => {
              setPage(p);
            }}
            total={totalData}
            itemRender={paginationRender}
          />
        ) : null}
      </ContainerView>
    </Container>
  );
}

export default WalletList;
